import React from "react";
import {StoreProductForm} from "../components/store-products-form";
import { StoreProductsDetails } from "../components/promotion/store-products-details";

export const StoreProductPage: React.FC = () => <StoreProductForm/>;

export const StoreProductPromotionDetails: React.FC = () =><StoreProductsDetails />
